import { render, staticRenderFns } from "./SimiConnectCaseStudy.vue?vue&type=template&id=28810278&scoped=true"
import script from "./SimiConnectCaseStudy.vue?vue&type=script&lang=js"
export * from "./SimiConnectCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./SimiConnectCaseStudy.vue?vue&type=style&index=0&id=28810278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28810278",
  null
  
)

export default component.exports